import { Navigate } from "react-router-dom";
import { getUserInfo } from "../utils/auth";
import Cookies from 'js-cookie';
const PublicRoute = ({ children }) => {
  const info = getUserInfo();
    const token = Cookies.get('Auth_Token');

    if (token && info?.user?.role) {
      // If logged in, stay on current page or go to learning-zone
      return <Navigate to={window.location.pathname.startsWith('/learning-zone') 
               ? window.location.pathname 
               : '/learning-zone'} replace />;
    }   
 // if (token && info?.user?.role ==='Admin') return <Navigate to="/admin" />;
  return children;
};
export default PublicRoute;
